// Upload permission: Only Level 0
export const canUploadFiles = (adminLevel) => adminLevel === 0;

// Remove others' reservations: Level 0, 1 and 2
export const canRemoveOthersReservations = (adminLevel) =>
  adminLevel === 0 || adminLevel === 1 || adminLevel === 2;

// Remove own reservation: Level 3 and 4 (students)
export const canRemoveOwnReservation = (adminLevel) => adminLevel >= 3;

// Admin can reserve for other users: Level 0, 1 and 2
export const canReserveForOthers = (adminLevel) =>
  adminLevel === 0 || adminLevel === 1 || adminLevel === 2;

// Regular users (students) can make reservations if Level 3 or 4
export const canMakeReservation = (adminLevel) => adminLevel >= 3;

// Reservation rule definitions per admin level
export const reservationRules = (adminLevel) => {
  if (adminLevel === 3 || adminLevel === 4) {
    return {
      allowedBuilding: "buildingA",
      maxHoursMorning: 2,
      maxHoursAfternoon: 2,
      fromHour: adminLevel === 3 ? 22 : 20,
      maxSimultaneousRooms: 1,
    };
  }

  // No restriction for Level 0, 1 and 2
  return null;
};
